import React from 'react'

const DisclaimerModal = (props) => {
    return (
        <div className="bgmain">
            <div className="header">
                <div className="header-box">
                    <div className="p1">
                        <p>
                            This application is developed solely for educational purposes. It is intended to provide users with a basic understanding of financial instruments, trading concepts, and market strategies. No real money is involved, and this app does not support or facilitate any real-world trading or financial transactions.
                        </p>
                        <p>
                            All data, prices, and simulations presented within the app are purely fictitious or for demonstration purposes and may not reflect real market conditions. Users are advised not to rely on the content for actual investment decisions.
                        </p>
                        <p>
                            This software is completely free and provided as a learning tool. We do not promote or encourage any specific financial product, instrument, or service. Use of the app is entirely at the user's discretion, and we are not responsible for any financial decisions made outside this platform.
                        </p>
                        <div className='text-center'>
                            <button className="btn btn-primary btnmain" onClick={() => props.closeDisclaimerModal()}>I acknowledge</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default DisclaimerModal